export const ellipsis = (text: string, maxLength: number) => {
  const ellipsis = '/…/'
  if (text.length > maxLength) {
    return text.slice(0, -ellipsis.length + maxLength / 2) + ellipsis + text.slice(text.length - maxLength / 2)
  }
  return text
}
